import TelegramBotAPI from '../../api/telegramBot';

const state = {
  connectionStatus: 'disconnected',
  notificationSettings: {},
  isLoading: false,
};

const getters = {
  isConnected: state => state.connectionStatus === 'connected',
  isConnecting: state => state.connectionStatus === 'connecting',
  isDisconnected: state => state.connectionStatus === 'disconnected',
  isError: state => state.connectionStatus === 'error',
};

const actions = {
  async getTelegramBotStatus({ commit }, { accountId, userId }) {
    try {
      const response = await TelegramBotAPI.getStatus(accountId);
      commit('SET_CONNECTION_STATUS', response.data.connected ? 'connected' : 'disconnected');
      return response.data;
    } catch (error) {
      console.error('Error getting Telegram bot status:', error);
      commit('SET_CONNECTION_STATUS', 'disconnected');
      throw error;
    }
  },

  async generateTelegramConnectionLink({ commit }, { accountId, userId }) {
    try {
      commit('SET_LOADING', true);
      // No need to pass user_identifier - backend will use current user's access token
      const response = await TelegramBotAPI.connect();
      
      if (response.data.success) {
        return {
          success: true,
          connection_link: response.data.connection_link,
          start_command: response.data.start_command,
          access_token: response.data.access_token,
        };
      } else {
        throw new Error(response.data.error || 'Failed to generate connection link');
      }
    } catch (error) {
      console.error('Error generating connection link:', error);
      commit('SET_CONNECTION_STATUS', 'error');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async disconnectTelegramBot({ commit }, { accountId, userId }) {
    try {
      const response = await TelegramBotAPI.disconnect();
      return response.data;
    } catch (error) {
      console.error('Error disconnecting Telegram bot:', error);
      throw error;
    }
  },

  async getNotificationSettings({ commit, dispatch, rootGetters }, { accountId }) {
    try {
      await dispatch('userNotificationSettings/get', {}, { root: true });
      const telegramFlags = rootGetters['userNotificationSettings/getSelectedTelegramFlags'] || [];
      return { 
        success: true,
        selected_telegram_flags: telegramFlags
      };
    } catch (error) {
      console.error('Error getting notification settings:', error);
      throw error;
    }
  },

  async updateTelegramNotificationSetting({ commit, dispatch, state, rootState, rootGetters }, { accountId, notificationType, enabled }) {
    try {
      console.log('updateTelegramNotificationSetting called with:', { accountId, notificationType, enabled });
      
      // Get current settings
      await dispatch('userNotificationSettings/get', {}, { root: true });
      const currentTelegramFlags = rootGetters['userNotificationSettings/getSelectedTelegramFlags'] || [];
      console.log('Current telegram flags:', currentTelegramFlags);
      
      // Update telegram flags
      let updatedTelegramFlags;
      if (enabled) {
        updatedTelegramFlags = [...currentTelegramFlags, notificationType];
      } else {
        updatedTelegramFlags = currentTelegramFlags.filter(flag => flag !== notificationType);
      }
      console.log('Updated telegram flags:', updatedTelegramFlags);
      
      // Update settings - preserve existing email and push flags
      const currentEmailFlags = rootGetters['userNotificationSettings/getSelectedEmailFlags'] || [];
      const currentPushFlags = rootGetters['userNotificationSettings/getSelectedPushFlags'] || [];
      console.log('Current email flags:', currentEmailFlags);
      console.log('Current push flags:', currentPushFlags);
      
      console.log('Calling userNotificationSettings/update with:', {
        selectedEmailFlags: currentEmailFlags,
        selectedPushFlags: currentPushFlags,
        selectedTelegramFlags: updatedTelegramFlags
      });
      
      await dispatch('userNotificationSettings/update', {
        selectedEmailFlags: currentEmailFlags,
        selectedPushFlags: currentPushFlags,
        selectedTelegramFlags: updatedTelegramFlags
      }, { root: true });
      
      console.log('userNotificationSettings/update completed successfully');
      return { success: true };
    } catch (error) {
      console.error('Error updating notification setting:', error);
      throw error;
    }
  },

  async checkConnectionStatus({ dispatch, commit }, { accountId, userId }) {
    try {
      commit('SET_CONNECTION_STATUS', 'connecting');
      await dispatch('getTelegramBotStatus', { accountId, userId });
    } catch (error) {
      commit('SET_CONNECTION_STATUS', 'error');
    }
  },
};

const mutations = {
  SET_CONNECTION_STATUS(state, status) {
    state.connectionStatus = status;
  },
  SET_NOTIFICATION_SETTINGS(state, settings) {
    state.notificationSettings = settings;
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 